const initializedRoutes = new Set<string>();

export function hasInitializedRoute(routeName: string): boolean {
  return initializedRoutes.has(routeName);
}

export function markRouteInitialized(routeName: string): void {
  initializedRoutes.add(routeName);
}
